import React, { useEffect, useState } from "react";
import { editVideoCloud } from "../../api/api";
import { NecStore } from "../../store/necStore";
// import { UserLang } from "../../store/userStore";

const Vidgyor = (props) => {
  // const [vidgyor, setVidgyor] = useState([]);
  const [lan] = useState("ltr");
  const role = NecStore.useState((s) => s.setting);
  // const lan = UserLang.useState((s) => s.lan);
  // const [modalShow, setModalShow] = useState(false);
  // const [dashElements,setDashElements] = useState([]);
  // const [pageModalShow, setPageModalShow] = useState(false);

  // const option = [
  //   { value: 'VIDGYOR', label: <LabelImage url={"https://www.vidgyor.com/assets/images/Logo.png"} name={"VIDGYOR"} height={"30px"} >  </LabelImage> }
  // ]

  useEffect(() => {}, []);

  //  const vidgyorChange=(value) =>
  //  {
  //     setVidgyor(value);
  //
  //  }

  const editSave = async () => {
    // setLoading(true);
    /* eslint-disable no-unused-vars */

    const result = await editVideoCloud(props.type).then(
      (result) => {
        //  setDashElements(result.data);
        //  setLoading(false);
      },
      (error) => {
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  return (
    <div>
      <form onSubmit={editSave}>
        {/* <div className="row">
<div className="col-sm-6">
<div className="form-group">
       <div className="col-md-12" dir={lan==="rtl"?"rtl":"ltr"}>
       <label className={lan==="rtl"?"float-right":"float-left"}> */}
        {/* {!(lan==="rtl")&&<ToolTip 
            info={"Select the recommended element in the page"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
        {/* Live */}
        {/* &nbsp;{(lan==="rtl")&&<ToolTip 
            info={"Select the recommended element in the page"}
            place={lan==="rtl"?"left":"right"}/>} */}
        {/* </label> */}

        {/* <Select name="recommendation" className={lan==="rtl"?"form-control inside-select float-right":"form-control inside-select float-left"} default={vidgyor} options={option} onChange={vidgyorChange} >
        </Select> */}
        {/* <div className="row" style={{marginTop:'100px',backgroundColor:'#f2f2f2'}}>
          <div className="col-md-12" style={{marginTop:'20px'}}>
         <span>{recElem}</span>
         
         </div>
        </div> */}

        {/* </div>
    </div>
    </div>
    </div> */}

        <div className="row">
          <div className="col-12">
            <div
              className={
                lan === "rtl"
                  ? "btn-group btn-group-md float-left"
                  : "btn-group btn-group-md float-right"
              }
              role="group"
            >
              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: "100px", marginRight: "6px" }}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-success"
                style={{ width: "100px", marginRight: "6px" }}
                disabled={!role.production === true ? true : false}
                hidden={!role.production === true ? true : false}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Vidgyor;
